import { ButtonDownloadComponent } from '@app/shared';
import { EventEmitter } from '@angular/core';

export class ReviewConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor(dataCompleter: any) {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'No hay resultados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        version: {
          title: 'Version',
          filter: {
            inputClass: 'form-control',
          },
          sortDirection: 'desc'
        },
        revision: {
          title: 'Información completa (Sí/No)',
          filter: {
            type: 'checkbox',
            config: {
              true: 'Sí',
              false: 'No',
              resetText: 'Limpiar',
            },
          },
        },
        descripcion: {
          title: 'Descripcion',
          filter: false,
        },
        fecha: {
          title: 'Fecha',
          filter: false,
          // sortDirection: 'desc'
        },
        nombre_responsable: {
          title: 'Nombre',
          filter: {
            inputClass: 'form-control',
            type: 'completer',
            config: {
              completer: {
                data: dataCompleter,
                searchFields: 'nombre_responsable',
                titleField: 'nombre_responsable',
              },
            }
          },
        },
        apellidos_responsable: {
          title: 'Apellidos',
          filter: {
            inputClass: 'form-control',
            type: 'completer',
            config: {
              completer: {
                data: dataCompleter,
                searchFields: 'apellidos_responsable',
                titleField: 'apellidos_responsable',
                descriptionField: 'Apellidos responsable',
              },
            }
          },
        },
        historial_id: {
          title: 'Documento',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/review-document/shared/review-document-config.service.ts